import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Suppress errors from browser extensions (MetaMask, etc.) that React dev mode catches
window.addEventListener('error', (event) => {
  if (event.message?.includes('MetaMask') || event.filename?.includes('chrome-extension://')) {
    event.stopImmediatePropagation();
    event.preventDefault();
  }
});
window.addEventListener('unhandledrejection', (event) => {
  if (event.reason?.message?.includes('MetaMask') || event.reason?.stack?.includes('chrome-extension://')) {
    event.stopImmediatePropagation();
    event.preventDefault();
  }
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
